module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"documents":"Documents of interest"},"fr":{"documents":"Documents utiles"}}')
  delete Component.options._Ctor
}
